/**
 * Autoscrolls product carousels (slideshow-component[data-autoscroll="<ms>"]) while they are in the
 * viewport. Autoscroll stops permanently once the visitor interacts with the carousel.
 */
const INTERACTION_EVENTS = ['pointerdown', 'touchstart', 'wheel', 'keydown', 'focusin'];

/** @param {HTMLElement} carousel */
function initAutoscroll(carousel) {
  const delay = parseInt(carousel.dataset.autoscroll ?? '', 10);
  if (!delay || delay <= 0 || carousel.dataset.autoscrollReady) return;
  carousel.dataset.autoscrollReady = 'true';

  /** @type {ReturnType<typeof setInterval> | undefined} */
  let timer;

  const advance = () => {
    if (document.hidden) return;
    const { slides, current, visibleSlides } = /** @type {any} */ (carousel);
    if (!slides?.length) return;
    // Advance by a single slide, wrapping back to the start once the last slide is in view.
    const lastSlideVisible = visibleSlides?.includes(slides[slides.length - 1]);
    /** @type {any} */ (carousel).select(lastSlideVisible ? 0 : current + 1);
  };

  const start = () => {
    if (!timer) timer = setInterval(advance, delay);
  };

  const stop = () => {
    clearInterval(timer);
    timer = undefined;
  };

  const observer = new IntersectionObserver(([entry]) => (entry?.isIntersecting ? start() : stop()), {
    threshold: 0.5,
  });

  const onInteraction = () => {
    stop();
    observer.disconnect();
    for (const name of INTERACTION_EVENTS) carousel.removeEventListener(name, onInteraction);
  };

  for (const name of INTERACTION_EVENTS) carousel.addEventListener(name, onInteraction, { passive: true });
  observer.observe(carousel);
}

function initAll() {
  document.querySelectorAll('slideshow-component[data-autoscroll]').forEach((el) => initAutoscroll(/** @type {HTMLElement} */ (el)));
}

initAll();
// Re-run when sections are added or re-rendered in the theme editor.
document.addEventListener('shopify:section:load', initAll);
